import { Location, NavigateFunction } from "react-router-dom";

import { setToLocalStorage } from "utils";
import { BillEntriesNavigationFetchContext, BillEntriesNavigationState } from "recoils";
import { MultiSelectControlledOption } from "components";
import { AppliedFiltersDisplay } from "./components/bills-recalculation/types";
import {
  BILLS_RECALCULATION_FIELD_LABELS,
  BILLS_RECALCULATION_QUERY_PARAM_KEYS,
  UTILITY_BILL_PAGE,
} from "./consts";

export const getMuiTableBodyRowProps = (
  row: any,
  saveCurrentUrl: () => void,
  currentUrl: Location,
  navigate: NavigateFunction,
  summaryDocumentID: string | null,
  billIds: string[],
  totalCount: number,
  setBillEntriesNavigation: (state: BillEntriesNavigationState | null) => void,
  fetchContext?: BillEntriesNavigationFetchContext | null,
) => ({
  onClick: () => {
    saveCurrentUrl();
    setToLocalStorage("dataEntries", JSON.stringify(row?.row));
    window.sessionStorage.setItem(
      "summaryDocumentID",
      row?.row?.original?.id as any,
    );
    setToLocalStorage(
      "Summary_URL",
      currentUrl.pathname + currentUrl.search,
    );
    setToLocalStorage("type", "Summary");
    setBillEntriesNavigation({ ids: billIds, totalCount, fetchContext });
    navigate(`${UTILITY_BILL_PAGE.ABSOLUTE_PATH(row?.row?.original?.id)}`);
  },
  sx: {
    cursor: "pointer",
    backgroundColor:
      row.row.original.id === summaryDocumentID ? "#DCDCDC" : "",
  },
});

/**
 * Filter query params accepted by the recalculation endpoints (POST /recalculation/bills/*) —
 * a subset of queryObject: excludes pagination/sort/duplicates-view fields.
 */
export const pickBillsRecalculationQueryParams = (
  queryObject: Record<string, unknown>,
): Record<string, unknown> => {
  const picked: Record<string, unknown> = {};
  BILLS_RECALCULATION_QUERY_PARAM_KEYS.forEach((key) => {
    if (queryObject[key] !== undefined) picked[key] = queryObject[key];
  });
  return picked;
};

/** "Applied Filters" grid for the recalculation modal — shows only what's actually in billsRecalculationQueryParams. */
export const buildBillsRecalculationDisplayFilters = (
  billsRecalculationQueryParams: Record<string, unknown>,
  siteIds: MultiSelectControlledOption[],
  totalSitesCount: number,
): AppliedFiltersDisplay => {
  const siteLabel = (() => {
    if (siteIds.length === 0 || siteIds.length === totalSitesCount)
      return "All Sites";
    const [first, ...rest] = siteIds;
    return rest.length > 0
      ? `${first.label} +${rest.length} more`
      : first.label;
  })();

  return Object.entries(billsRecalculationQueryParams).reduce<
    AppliedFiltersDisplay
  >((entries, [key, value]) => {
    if (key === "siteIds") {
      entries.push({ label: "Sites", value: siteLabel, isOn: true });
      return entries;
    }
    if (value === null || value === undefined || value === "") return entries;
    if (Array.isArray(value) && value.length === 0) return entries;
    if (typeof value === "boolean" && !value) return entries;

    entries.push({
      label: BILLS_RECALCULATION_FIELD_LABELS[key] || key,
      value:
        typeof value === "boolean"
          ? "On"
          : Array.isArray(value)
          ? value.join(", ")
          : String(value),
      isOn: true,
    });
    return entries;
  }, []);
};
